// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super()

    this.swiperElement = this.querySelector('[data-product-detail-swiper]')

    this.swiperOptions = {
      direction: 'horizontal',
    }

    this.init()
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
    })
    Fancybox.bind('[data-fancybox]', {
      animated: false,
      showClass: false,
    })
  }
}

if (!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper)
}
